module.exports = __webpack_public_path__ + "dash_20_app_assets/img/code.dda8e901.png";